import { Helmet } from 'react-helmet-async';
import { useState } from 'react';
// @mui
import { Stack, Typography, Grid, Button } from '@mui/material';
import Link from '@mui/material/Link';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

import TextField from '@mui/material/TextField';
import moment from 'moment';

dayjs.extend(utc);
dayjs.extend(timezone);

// ----------------------------------------------------------------------

export default function HomePage(props) {
  return (
    <>
      <Helmet>
        <title> Home | OneT | Leading DevSecOps Service Provider</title>
      </Helmet>

      <Grid
        style={{
          top: 0,
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
        }}
      >
        <Grid
          style={{
            zIndex: -1,
            position: 'absolute',
            top: 0,
            width: '100%',
            backgroundColor: '#1b0049',
            backgroundImage: `url(${props.data ? props.data.event_bg_fullPath : ''})`,
            backgroundPosition: 'center',
            backgroundPositionY: 0,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            height: '100%',

            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
          }}
        />

        <Grid
          style={{
            zIndex: -1,
            position: 'absolute',
            top: 0,
            width: '100%',
            backgroundColor: '#000000',
            height: '100%',
            opacity: 0.9,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
          }}
        />

        <Grid
          style={{
            zIndex: 2,
            marginTop: 120,
            width: '100%',
            display: 'flex',
            paddingLeft: 25,
            paddingRight: 25,
            paddingTop: 60,
            paddingBottom: 80,
            flexDirection: 'row',
            backgroundColor: 'rgba(0, 0, 0, 1)',
            justifyContent: 'center',
          }}
        >
          <Grid style={{ maxWidth: 1200, display: 'flex', flexDirection: 'column' }}>
            {props.data && props.data.logo ? <img src={props.data.logo} alt="img" width={200} /> : null}

            <Grid container style={{ marginTop: 30 }}>
              <Grid item md={3} xs={12} style={{ display: 'flex', flexDirection: 'row' }}>
                <img src="/assets/calendaricon.png" alt="calendaricon" height={20} />
                <Typography style={{ paddingLeft: 10, fontSize: 14, color: 'white' }}>
                  {props.data ? `${moment.utc(props.data.date).format('DD/MM/YYYY')}` : ''}
                </Typography>
              </Grid>
            </Grid>
            <Typography style={{ fontWeight: 'bold', fontSize: 40, color: 'white', textTransform: 'uppercase' }}>
              {props.data ? props.data.title : ''}
            </Typography>

            <Typography
              sx={{
                whiteSpace: 'pre-wrap', // respects line breaks + wraps
                overflowWrap: 'break-word', // breaks long words
                wordBreak: 'break-word', // fallback for older browsers
              }}
              style={{ fontWeight: 300, fontSize: 14, color: 'white', opacity: 0.8 }}
            >
              {props.data ? props.data.description : ''}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
